'use strict';

var _slicedToArray = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/slicedToArray");

var destroyCircular = function destroyCircular(from, seen) {
  var to = Array.isArray(from) ? [] : {};
  seen.push(from);

  for (var _i = 0, _Object$entries = Object.entries(from); _i < _Object$entries.length; _i++) {
    var _ref3 = _Object$entries[_i];

    var _ref2 = _slicedToArray(_ref3, 2);

    var key = _ref2[0];
    var value = _ref2[1];

    if (typeof value === 'function') {
      continue;
    }

    if (!value || typeof value !== 'object') {
      to[key] = value;
      continue;
    }

    if (!seen.includes(from[key])) {
      to[key] = destroyCircular(from[key], seen.slice());
      continue;
    }

    to[key] = '[Circular]';
  }

  var commonProperties = ['name', 'message', 'stack', 'code'];

  for (var _i2 = 0, _commonProperties = commonProperties; _i2 < _commonProperties.length; _i2++) {
    var property = _commonProperties[_i2];

    if (typeof from[property] === 'string') {
      to[property] = from[property];
    }
  }

  return to;
};

var serializeError = function serializeError(value) {
  if (typeof value === 'object') {
    return destroyCircular(value, []);
  } // People sometimes throw things besides Error objects…


  if (typeof value === 'function') {
    // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return "[Function: ".concat(value.name || 'anonymous', "]");
  }

  return value;
};

module.exports = serializeError; // TODO: Remove this for the next major release

module.exports.default = serializeError;